import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
  FaHeart,
  FaShoppingCart,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaEnvelope
} from "react-icons/fa";
import { useAppContext } from "../context/AppContext";
import ProductCard from "../components/ProductCard";

const ProductDetail = () => {
  const { id } = useParams();
  const { products, wishlist, toggleWishlist, addToCart } = useAppContext();
  const [product, setProduct] = useState(null);
  const [selectedColor, setSelectedColor] = useState("Beige");
  const [selectedSize, setSelectedSize] = useState("Standard");
  const [quantity, setQuantity] = useState(1);
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    const foundProduct = products.find((p) => p.id === parseInt(id));
    if (foundProduct) {
      setProduct(foundProduct);
      setMainImage(foundProduct.image);
    }
  }, [id, products]);

  if (!product) {
    return <div>Loading...</div>;
  }

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" />);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} />);
    }
    return stars;
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  const relatedProducts = products
    .filter((p) => p.category === product.category && p.id !== product.id)
    .slice(0, 4);

  return (
    <>
      <div className="container product-detail" style={{marginTop: "50px"}}>
        <div className="product-gallery">
          <div className="main-image">
            <img src={mainImage} alt={product.name} />
          </div>
          <div className="thumbnails">
            <div
              className={`thumbnail ${
                mainImage === product.image ? "active" : ""
              }`}
              onClick={() => setMainImage(product.image)}
            >
              <img src={product.image} alt="Thumbnail 1" />
            </div>

            <div
              className={`thumbnail ${
                mainImage ===
                "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80"
                  ? "active"
                  : ""
              }`}
              onClick={() =>
                setMainImage(
                  "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80"
                )
              }
            >
              <img
                src="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80"
                alt="Thumbnail 3"
              />
            </div>
          </div>
        </div>
        <div className="product-info-detail">
          <h1 className="product-title">{product.name}</h1>
          <div className="product-price-detail">
            ${product.price.toFixed(2)}
          </div>
          <div className="product-rating">
            <div className="stars">{renderStars(product.rating)}</div>
            <span className="review-count">({product.rating})</span>
          </div>
          <div className="product-description">
            <p>
              This premium product is made from high-quality materials to ensure
              durability and comfort. Perfect for enhancing your living space
              with style and elegance.
            </p>
            <ul>
              <li>Premium fabric material</li>
              <li>Easy to clean and maintain</li>
              <li>Available in multiple colors</li>
              <li>{product.isNew ? "New arrival" : "Classic design"}</li>
            </ul>
          </div>
          <div className="product-meta">
            <div className="meta-item">
              <span className="meta-label">Category:</span>
              <span className="meta-value">
                {product.category.charAt(0).toUpperCase() +
                  product.category.slice(1).replace("-", " ")}
              </span>
            </div>
            <div className="meta-item">
              <span className="meta-label">Brand:</span>
              <span className="meta-value">
                {product.brand.charAt(0).toUpperCase() + product.brand.slice(1)}
              </span>
            </div>
            <div className="meta-item">
              <span className="meta-label">Availability:</span>
              <span className="meta-value">In Stock</span>
            </div>
          </div>
          <div className="variations">
            <div className="variation-title">Color:</div>
            <div className="variation-options">
              {["Beige", "Gray", "Blue"].map((color) => (
                <button
                  key={color}
                  className={`variation-btn ${
                    selectedColor === color ? "active" : ""
                  }`}
                  onClick={() => setSelectedColor(color)}
                >
                  {color}
                </button>
              ))}
            </div>
            <div className="variation-title">Size:</div>
            <div className="variation-options">
              {["Standard", "Queen", "King"].map((size) => (
                <button
                  key={size}
                  className={`variation-btn ${
                    selectedSize === size ? "active" : ""
                  }`}
                  onClick={() => setSelectedSize(size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>
          <div className="quantity-selector">
            <button
              className="quantity-btn quantity-minus"
              onClick={decreaseQuantity}
            >
              -
            </button>
            <input
              type="number"
              min="1"
              value={quantity}
              className="quantity-input"
              onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
            />
            <button
              className="quantity-btn quantity-plus"
              onClick={increaseQuantity}
            >
              +
            </button>
          </div>
          <div className="detail-actions">
            <button
              className={`btn btn-outline ${
                wishlist.includes(product.id) ? "active" : ""
              }`}
              onClick={() => toggleWishlist(product.id)}
            >
              <FaHeart />{" "}
              {wishlist.includes(product.id)
                ? "In Wishlist"
                : "Add to Wishlist"}
            </button>
            <button
              className="btn"
              onClick={() => addToCart(product.id, quantity)}
            >
             <FaEnvelope /> Inquiry

            </button>
          </div>
        </div>
      </div>

      <section className="container" id="related">
        <div className="section-title">
          <h2>Related Products</h2>
        </div>
        <div className="products-grid">
          {relatedProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </>
  );
};

export default ProductDetail;
